import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import ImageWithFallback from '../components/ImageWithFallback';
import { ShoppingBag, Search, Filter } from 'lucide-react';
const Shop = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const products = [{
    id: 'prod-1',
    name: 'Premium Prayer Mat',
    image: 'https://images.unsplash.com/photo-1584286595398-a59b3a3a5908?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    price: 49.99,
    category: 'prayer',
    description: 'Luxurious, comfortable prayer mat with intricate design.',
    inStock: true
  }, {
    id: 'prod-2',
    name: 'Travel Ihram Set',
    image: 'https://images.unsplash.com/photo-1605518215584-5ba74df6e538?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
    price: 39.99,
    category: 'clothing',
    description: 'High-quality ihram set for Umrah and Hajj.',
    inStock: true
  }, {
    id: 'prod-3',
    name: 'Digital Quran Reader',
    image: 'https://images.unsplash.com/photo-1609599006353-e629a7d802db?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    price: 129.99,
    category: 'electronics',
    description: 'Modern digital Quran reader with translation and audio.',
    inStock: true
  }, {
    id: 'prod-4',
    name: 'Travel Prayer Clock',
    image: 'https://images.unsplash.com/photo-1584986465167-b8cb1c123041?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    price: 34.99,
    category: 'electronics',
    description: 'Compact prayer clock with automatic location adjustment.',
    inStock: true
  }, {
    id: 'prod-5',
    name: 'Kembara Ustaz T-Shirt',
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1480&q=80',
    price: 24.99,
    category: 'clothing',
    description: 'Comfortable cotton t-shirt with Kembara Ustaz logo.',
    inStock: true
  }, {
    id: 'prod-6',
    name: 'Islamic Calligraphy Art',
    image: 'https://images.unsplash.com/photo-1579783900882-c0d3dad7b119?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    price: 79.99,
    category: 'decor',
    description: 'Beautiful Islamic calligraphy art for home decoration.',
    inStock: false
  }, {
    id: 'prod-7',
    name: 'Travel Pillow Set',
    image: 'https://images.unsplash.com/photo-1553481187-be93c21490a9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    price: 29.99,
    category: 'travel',
    description: 'Comfortable travel pillow set for long journeys.',
    inStock: true
  }, {
    id: 'prod-8',
    name: 'Pocket Dua Book',
    image: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80',
    price: 14.99,
    category: 'books',
    description: 'Compact book of essential duas for travelers.',
    inStock: true
  }];
  const categories = [{
    id: 'all',
    name: 'All Products'
  }, {
    id: 'prayer',
    name: 'Prayer Accessories'
  }, {
    id: 'clothing',
    name: 'Clothing'
  }, {
    id: 'electronics',
    name: 'Electronics'
  }, {
    id: 'travel',
    name: 'Travel Accessories'
  }, {
    id: 'books',
    name: 'Books'
  }, {
    id: 'decor',
    name: 'Home Decor'
  }];
  const filteredProducts = products.filter(product => {
    // Filter by category
    if (selectedCategory !== 'all' && product.category !== selectedCategory) {
      return false;
    }
    // Filter by search term
    if (searchTerm && !product.name.toLowerCase().includes(searchTerm.toLowerCase())) {
      return false;
    }
    return true;
  });
  return <div className="w-full" data-id="element-964">
      <PageHeader title="Shop KU" subtitle="Quality products for your spiritual journey" backgroundImage="https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" data-id="element-965" />
      {/* Search and Filter */}
      <section className="py-8 bg-navy-50" data-id="element-966">
        <div className="container mx-auto px-4 md:px-8" data-id="element-967">
          <div className="flex flex-col md:flex-row gap-4" data-id="element-968">
            <div className="flex-1" data-id="element-969">
              <div className="relative" data-id="element-970">
                <input type="text" placeholder="Search products..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full p-3 pl-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-500" data-id="element-971" />
                <Search size={20} className="absolute left-3 top-3.5 text-gray-400" data-id="element-972" />
              </div>
            </div>
            <div className="md:w-64" data-id="element-973">
              <button className="w-full bg-navy-900 hover:bg-navy-800 text-white p-3 rounded-md font-medium transition-colors flex items-center justify-center" data-id="element-974">
                <Filter size={18} className="mr-2" data-id="element-975" />
                Filter Products
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* Categories */}
      <section className="py-6 bg-white border-b" data-id="element-976">
        <div className="container mx-auto px-4 md:px-8" data-id="element-977">
          <div className="flex overflow-x-auto pb-2 gap-2 md:gap-4 md:justify-center" data-id="element-978">
            {categories.map(category => <button key={category.id} onClick={() => setSelectedCategory(category.id)} className={`px-4 py-2 whitespace-nowrap rounded-md transition-colors ${selectedCategory === category.id ? 'bg-navy-900 text-white' : 'bg-gray-100 text-navy-900 hover:bg-gray-200'}`} data-id="element-979">
                {category.name}
              </button>)}
          </div>
        </div>
      </section>
      {/* Products Grid */}
      <section className="py-16 bg-white" data-id="element-980">
        <div className="container mx-auto px-4 md:px-8" data-id="element-981">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-982">
            {filteredProducts.map(product => <div key={product.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-983">
                <div className="relative h-48 md:h-56" data-id="element-984">
                  <ImageWithFallback src={product.image} alt={product.name} className="w-full h-full object-cover" data-id="element-985" />
                  {!product.inStock && <div className="absolute top-0 right-0 bg-red-500 text-white px-3 py-1 text-sm font-medium" data-id="element-986">
                      Out of Stock
                    </div>}
                </div>
                <div className="p-4" data-id="element-987">
                  <h3 className="font-bold text-navy-900" data-id="element-988">{product.name}</h3>
                  <p className="text-navy-700 text-sm mt-1 mb-3 line-clamp-2" data-id="element-989">
                    {product.description}
                  </p>
                  <div className="flex justify-between items-center" data-id="element-990">
                    <div className="text-lg font-bold text-gold-500" data-id="element-991">
                      ${product.price}
                    </div>
                    <button className={`flex items-center text-sm px-3 py-1.5 rounded ${product.inStock ? 'bg-navy-900 hover:bg-navy-800 text-white' : 'bg-gray-300 text-gray-600 cursor-not-allowed'}`} disabled={!product.inStock} data-id="element-992">
                      <ShoppingBag size={16} className="mr-1" data-id="element-993" />
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* Benefits */}
      <section className="py-16 bg-navy-50" data-id="element-994">
        <div className="container mx-auto px-4 md:px-8" data-id="element-995">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-996">
            <div className="text-center p-6" data-id="element-997">
              <div className="bg-white w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4" data-id="element-998">
                <ShoppingBag size={32} className="text-navy-900" data-id="element-999" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-1000">
                Quality Products
              </h3>
              <p className="text-navy-700" data-id="element-1001">
                All our products are carefully selected to ensure the highest
                quality for our customers.
              </p>
            </div>
            <div className="text-center p-6" data-id="element-1002">
              <div className="bg-white w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4" data-id="element-1003">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-navy-900" data-id="element-1004">
                  <path d="M12 2L2 7l10 5 10-5-10-5z" data-id="element-1005"></path>
                  <path d="M2 17l10 5 10-5M2 12l10 5 10-5" data-id="element-1006"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-1007">
                Worldwide Shipping
              </h3>
              <p className="text-navy-700" data-id="element-1008">
                We ship our products to customers around the world with reliable
                delivery services.
              </p>
            </div>
            <div className="text-center p-6" data-id="element-1009">
              <div className="bg-white w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4" data-id="element-1010">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-navy-900" data-id="element-1011">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" data-id="element-1012"></path>
                  <polyline points="22 4 12 14.01 9 11.01" data-id="element-1013"></polyline>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-1014">
                Satisfaction Guarantee
              </h3>
              <p className="text-navy-700" data-id="element-1015">
                Not satisfied with your purchase? We offer hassle-free returns
                within 30 days.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Shop;